import { render, staticRenderFns } from "./OrdersPending.vue?vue&type=template&id=34d7cbc7"
import script from "./OrdersPending.vue?vue&type=script&lang=js"
export * from "./OrdersPending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports